import styled from 'styled-components';

export default styled.div`
    .ant-layout {
        height: calc(100vh);

        .ant-layout-header {
            background: #ffffff;
            padding: 0 16px;
            line-height: 48px;
            height: 48px;
        }

        .ant-layout-content {
            overflow: auto;
        }
    }

    /* Changelog pinned to the far right of the tab bar (antd tabBarExtraContent).
       Styled to match a real antd tab: 12px 0 padding (so it fills the 46px nav
       height and its underline width equals the text), #1890ff active color, and a
       2px ::after underline at the nav bottom that lines up with the ink bar. */
    .changelog-tab {
        position: relative;
        display: inline-block;
        padding: 12px 0;
        margin-right: 16px;
        font-size: 14px;
        line-height: 22px;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.85);
        transition: color 0.3s;
    }

    .changelog-tab:hover {
        color: #40a9ff;
    }

    .changelog-tab--active {
        color: #1890ff;
        text-shadow: 0 0 0.25px currentColor;
    }

    .changelog-tab--active::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 2px;
        background: #1890ff;
    }
`;
